__turbopack_context__.v({
  "className": "comfortaa_245f9678-module__4aospW__className",
  "variable": "comfortaa_245f9678-module__4aospW__variable",
});
